<template>
    <fixed-header :threshold="threshold" @change="updateFixedStatus">
        <div>
            <div class="header">
                <main-container>
                    <header-logo :small="sticky" />
                    <header-user :initialName="user.fullName" :permission="user.permission" />
                </main-container>
            </div>
        </div>
    </fixed-header>
</template>
<script>
import FixedHeader from "vue-fixed-header";
import HeaderUser from "src/components/header/private/HeaderUser.vue";
import HeaderLogo from "src/components/header/private/HeaderLogo.vue";

export default {
    props: ["user"],
    components: {
        FixedHeader,
        HeaderUser,
        HeaderLogo,
    },
    data() {
        return {
            threshold: 110,
            sticky: false,
        };
    },
    methods: {
        updateFixedStatus(next) {
            this.threshold = next ? 60 : 110;
            this.sticky = next;
        },
    },
};
</script>

<style lang="sass" scoped>
.header
    padding: 0 10px
    height: 110px
    display: flex
    border-bottom: 1px solid $color-secondary
    background: white

    .main-container
        display: flex
        align-items: center
        flex-grow: 1

.logo
    margin-right: auto

.vue-fixed-header
    height: 110px

.vue-fixed-header--isFixed
    .header
        position: fixed
        top: 0
        z-index: 10
        width: 100%
        animation: appear .15s ease-out
        height: 60px
        border-bottom: 0
        box-shadow: 0 0 2px rgba(0,0,0,0.5)

@keyframes appear
    0%
        transform: translateY(-110px)
    100%
        transform: translateY(0px)

@media print
    .header
        height: auto !important
        padding: 0
        border: none
        box-shadow: none !important

    .main-container
        margin-top: 9mm !important
        padding-bottom: 8mm

    .vue-fixed-header
        height: auto

        &--isFixed
            .header
                position: static
</style>
